export default __webpack_public_path__ + "static/media/users.ff69c469.svg";